import { useCallback, useEffect, useState } from "react";
import {

  DesignTokens,
  Row,
  Col,
  Button,
  UndoIcon,
  

} from "melco-ui";

//import moment from "moment";
import { useTranslation } from "react-i18next";
import { isEmpty, some } from "lodash-es";

import { Search } from "../search/Search";
import { UsersListFiltersType } from "../../hooks/users/UsersListFilterType";
import { CountrySelect } from "../common/CountrySelect";

const { spacings } = DesignTokens;

type UsersListFilterProps = {
  onFiltersChange: (filters: UsersListFiltersType | undefined) => void;
};


export const UsersListFilter: React.FC<UsersListFilterProps> = ({
  onFiltersChange,
}) => {
  const { t } = useTranslation();

  const [usersFilter, setUsersFilter] = useState<
    UsersListFiltersType | undefined
  >(undefined);

  const [firstNameValue, setFirstNameValue] = useState("");
  const [lastNameValue, setLastNameValue] = useState("");
  const [userNameValue, setUserNameValue] = useState("");
  const [searchValue, setSearchValue] = useState("");


  useEffect(() => {
    console.log({ usersFilter })
    onFiltersChange(usersFilter);
  }, [usersFilter, onFiltersChange]);

  const resetFilter = useCallback(() => {
    setFirstNameValue("");
    setLastNameValue("");
    setUserNameValue("");
    setSearchValue("");
    setUsersFilter(undefined);

  }, []);

  return (
    <Row gutter={[spacings.middle, spacings.middle]}>
      <Col flex={0}>
        <Search
          onSearchInputChange={(value) => {
            setUsersFilter((prevFilter) => {
              return { ...prevFilter, searchText: value };
            });
          }}
          onChange={(e) => setSearchValue(e.target.value)}
          value={searchValue}

        />
      </Col>
      <Col flex={0}>
        <Search
          onSearchInputChange={(value) => {
            setUsersFilter((prevFilter) => {
              return { ...prevFilter, firstName: value };
            });
          }}
          onChange={(e) => setFirstNameValue(e.target.value)}
          value={firstNameValue}
          placeholder={t("users.filter.first_name")}
        />
      </Col>
      <Col flex={0}>
        <Search
          onSearchInputChange={(value) => {
            setUsersFilter((prevFilter) => {
              return { ...prevFilter, lastName: value };
            });
          }}
          onChange={(e) => setLastNameValue(e.target.value)}
          value={lastNameValue}
          placeholder={t("users.filter.last_name")}
        />
      </Col>
      <Col flex={0}>
        <Search
          onSearchInputChange={(value) => {
            setUsersFilter((prevFilter) => {
              return { ...prevFilter, userName: value };
            });
          }}
          onChange={(e) => setUserNameValue(e.target.value)}
          value={userNameValue}
          placeholder={t("users.filter.username")}
        />
      </Col>
      <Col flex={0}>
        <CountrySelect
          onChange={(value) => {
            setUsersFilter((prevFilter) => {
              return {
                ...prevFilter,
                countryCode: !isEmpty(value) ? value : undefined,
              };
            });
          }}
          value={usersFilter?.countryCode ?? undefined}
        ></CountrySelect>
      </Col>



      <Col xs={6} md={5} xl={3}>



        {some(usersFilter) && (
          <Button
            icon={<UndoIcon />}
            type="primary"
            onClick={resetFilter}
            data-cy-id="users-filter-reset"
            style={{ minWidth: "100%" }}
          >
            {t("filter.reset.button", { ns: "melco-common" })}
          </Button>
        )}

      </Col>
    </Row>

  );
};
